import { TRACK } from '@updater-core/lib/tracker';
import tracker from '@updater-core/interactors/shell/tracker';

export async function redirectIntoConsumerApp() {
  if (window.location.pathname.includes('/tvi')) {
    // all tvi urls are allowed
    tracker.actions.track({
      domain: 'mover',
      object: 'consumer_app_redirect',
      verb: TRACK,
      details: {
        productionized: true,
        tviRoute: true,
        redirected: false,
      },
    });
    return false;
  }

  const inConsumerApp = true;

  tracker.actions.track({
    domain: 'mover',
    object: 'consumer_app_redirect',
    verb: TRACK,
    details: {
      productionized: true,
      tviRoute: false,
      redirected: inConsumerApp,
    },
  });

  return inConsumerApp;
}
